<template>
  <div class="article_list">
    <div class="title">
      <p>文章列表</p>
    </div>
    <div class="doc_list">
      <ul>
        <li v-for="(item,index) in articleList" v-text="item.documentTitle" @click="clickArticle(item,index)"></li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'articleList',
  props:{
    articleList:{
      type:Array,
      required:true
    }
  },
  data(){
    return{};
  },
  methods:{
    /**
     * [clickArticle description]点击文章列表显示详情
     * @param  {[type]} article [description]所选文章
     * @return {[type]}         [description]
     */
    clickArticle(article,index){
      this.$emit('showArticleDetail',article);
      this.$emit('update:articleIndex',index);
    }
  }
}

</script>
<style scoped lang="less">
.article_list {
  width: 100%;

  .title {
    width: 100%;
    padding: 0 0 7px 14px;
    box-sizing: border-box;
    border-bottom: solid 1px #EBEFF2;
    font-size: 18px;
    font-weight: 400;
    color: rgba(42, 42, 42, 1);
    position: relative;

    &:before {
      content: ' ';
      position: absolute;
      top: 2px;
      left: 0;
      width: 2px;
      height: 18px;
      background: #4786FF;
    }
  }

  .doc_list {
    width: 100%;
    margin-top: 20px;

    li {
      font-size: 14px;
      font-weight: 400;
      color: rgba(62, 62, 62, 1);
      line-height: 20px;
      margin-bottom: 15px;
      cursor: pointer;
    }
  }
}

</style>
